import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=2ca74558&scoped=true"
import script from "./Menu2.vue?vue&type=script&lang=js"
export * from "./Menu2.vue?vue&type=script&lang=js"
import style0 from "./Menu2.vue?vue&type=style&index=0&id=2ca74558&prod&scoped=true&lang=css"
import style1 from "./Menu2.vue?vue&type=style&index=1&id=2ca74558&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca74558",
  null
  
)

export default component.exports